const common = {
    present: "present",
    user: "User",
    menu_overview: "Overview",
    menu_resume: "Resume",
    menu_portfolio: "Portfolio",
    menu_autobio: "Autobiography",
    menu_login: "Login",
    menu_logout: "Logout",
    menu_account: "Account",
    loading_msg: "Loading, please wait...",
    today: "Today",
    chat_tooltip: "Contact me",
    chat_placeholder: "Write a message"
};

const overview = {
    overview_title1: "KH's",
    overview_title2: "Demo Website",
    overview_introduction: `
        This is a personal website for demo.
        Demo the ability to develop and deploy a platform on-premises or on a cloud architecture.
        No matter frontend, backend or devOps tasks, all of them could be completed properly.
        Except for the UI design because I don't have any artistic talent...
    `,
    overview_scenarios: "Scenarios",
    overview_video1_title: "Event Map",
    overview_video2_title: "Vehicle Report",
    overview_video3_title: "Routing",
    overview_video4_title: "Multi Languages",
    overview_video5_title: "SSO (Single Sign-On)",
    overview_video6_title: "Micro Frontend",
    overview_video7_title: "CI/CD",
    overview_video1_desc: `
        A map shows which vehicle violate what kind of event which could be filtered by time range, severity,
        event type & vehicle. Also, there's a video in each event to clarify the situation better.
    `,
    overview_video2_desc: `
        A dashboard shows the event statistics which could be filtered by time range.
        The statistics can be classified as event severity, event type, event trend
        & vehicle's event count. The event severity statistics show the count in each severity.
        The event type statistics shows the count in each event type.
        The event trend statistics shows the trend of event count in the time range
        and a time granularity can be changed as yearly, monthly & daily.
        The vehicle's event count statistics shows the event count of each vehicle.
    `,
    overview_video3_desc: `
        A demo for route planning which can be used in the vehicle transport service.
        After pick up the source and destination, a optimize route will be shown on the map
        and a detail trip information can be presented to users.
        Besides, the route could be updated by adding or removing a via point for more flexiable route planning.
    `,
    overview_video4_desc: `
        A demo shows that multiple languages can be implemented for internationality.
        Every page can be shown in the corresponding language which could be set when users sign in.
    `,
    overview_video5_desc: `
        A demo shows that a SSO feature can be implemented in a platform
        which is composed of multiple websites. This feature allows users to enter their passwords only once,
        and use services everywhere and could avoid from phishing attack & password fatigue.
    `,
    overview_video6_desc: `
        A demo shows the a micro frontend can be implemented
        for more flexiable function component use.
        Each function component can be added or removed as an independent component,
        and reuse in other platforms without too much modification.
    `,
    overview_video7_desc: `
        A demo shows the development flow. When developers commit & push their code to GitLab,
        a CI/CD process will be triggered to do unit test, build & deploy to the server.
        After that, a new version of application is running without any complicated update procedures.
    `
};

const resume = {
    resume_info: "My Info",
    resume_info_lable_name: "Name",
    resume_info_lable_email: "Email",
    resume_info_name: "Kuen-Han Li",
    resume_education: "Education",
    resume_education_college: "National Taiwan University of Science and Technology (NTUST), Taipei, Taiwan",
    resume_education_college_master_date: "Jul. 2013",
    resume_education_college_master: "Candidate for Master of Engineering in Electronic and Computer Engineering",
    resume_education_college_bachelor_date: "Feb. 2010",
    resume_education_college_bachelor: "Candidate for Bachelor of Engineering in Electronic and Computer Engineering",
    resume_exp: "Work Experience",
    resume_exp_wistron: "Wistron Corporation, New Taipei, Taiwan",
    resume_exp_wistron_title: "Assistant Technical Manager, S/W R&D Dept. III",
    resume_exp_wistron_work1_title: "Autopilot information integration platform",
    resume_exp_wistron_work2_title: "AiEDR",
    resume_exp_wistron_work3_title: "ZigNeural",
    resume_exp_wistron_work4_title: "Zigfleet",
    resume_exp_wistron_work1_desc: "Developed an autopilot platform which is the first containerize service in Docker to monitor and managed intelligent bus.",
    resume_exp_wistron_work2_desc: "Developed a vedio detection management platform which is based on Kubernetes and this platform provides events and edge devices management.",
    resume_exp_wistron_work3_desc: "Developed backend services based on Kubeflow on the Amazon Elastic Kubernetes Service (EKS) for automatic AI model training and deployment.",
    resume_exp_wistron_work4_desc: "Developed a web-based fleet management platform on the Amazon Web Services (AWS) to monitor and manage vehicles, drivers, trips, etc.",
    resume_exp_iii: "Institute for Information Industry (III), Taipei, Taiwan",
    resume_exp_iii_title: "Engineer, Smart System Institute",
    resume_exp_iii_work1_title: "Disaster Monitoring and Pre-warning System",
    resume_exp_iii_work2_title: "WebAccess/NMS",
    resume_exp_iii_work3_title: "nCare IoT Management System",
    resume_exp_iii_work4_title: "SL GINet Management System Operation",
    resume_exp_iii_work5_title: "D-Link Edge Cloud System",
    resume_exp_iii_work6_title: "Deep Learning Intelligent Traffic System",
    resume_exp_iii_work1_desc: "Developed a web-based environment-aware management system to monitor environment data and issue disaster warning in the 5 km range. And an Earthquake Early Warning app was also developed for Android platform for more flexible application",
    resume_exp_iii_work2_desc: "Developed a web-based industrial device management system based on SNMP and ICMP protocols to monitor and manage the Advantech devices and other third-parties devices support SNMP protocol. And the system could manage up to 4,000 devices because of the distributed architecture design.",
    resume_exp_iii_work3_desc: "Developed a web-based IoT management system based on SNMP, ICMP, CAPWAP and Modbus protocols to monitor and manage the Nexcom devices. Also, a mobile management iOS app was developed for more flexible application.",
    resume_exp_iii_work4_desc: "Developed a web-based network management system to manage the microwave devices, BestLINK devices, and switches for Saint Luica which is the first product promoted to the world.",
    resume_exp_iii_work5_desc: "Developed the first web-based management system on the Amazon Web Services (AWS) and this system supports TR-069, SNMP, ICMP, and MQTT protocols to manage the D-Link devices.",
    resume_exp_iii_work6_desc: "Developed a traffic event warning and early warning module which is based on the deep learning to detect and predict objects for the intelligent traffic goals.",
    resume_skill: "Skills",
    resume_skill_programming: "Programming language",
    resume_skill_computer: "Computer",
    resume_skill_language: "Language",
    resume_skill_language_items: "Mandarin (native), English (excellent command of read and written English, good command of listen and spoken English)",
    resume_achivement: "Achivements",
    resume_achivement_aws: "AWS Certified Solutions Architect - Associate (SAA-C02)",
    resume_achivement_aws_date: "Aug. 2022",
    resume_achivement_scrum: "Scrum Master Accredited Certification",
    resume_achivement_scrum_date: "Sep. 2021",
    resume_achivement_ai: "Taiwan AI Academy Certificate",
    resume_achivement_ai_date: "Jan. 2019",
    resume_achivement_iii: "Excellent Skills Elite Award",
    resume_achivement_iii_date: "Aug. 2016",
    resume_patent: "Invention Patents",
    resume_patent_ai: "Method and Electronic Device of Updating Neural Network Model",
    resume_patent_ai_date: "Jan. 2022",
    resume_patent_ews: "Disaster Monitoring and Pre-Warning System and Method Thereof",
    resume_patent_ews_cn: "CN105225447B, Chinese",
    resume_patent_ews_cn_date: "Dec. 2017",
    resume_patent_ews_us: "US9373247B2, America",
    resume_patent_ews_us_date: "Jul. 2016",
    resume_patent_ews_tw: "I537889, Taiwan",
    resume_patent_ews_tw_date: "Jun. 2016",
    resume_publication: "Publications",
    resume_publication8_date: "Aug. 2016",
    resume_publication7_date: "Nov. 2015",
    resume_publication6_date: "Sep. 2015",
    resume_publication5_date: "Aug. 2013",
    resume_publication4_date: "Jul. 3-5 2013",
    resume_publication3_date: "Apr. 2013",
    resume_publication2_date: "May 6-9 2012",
    resume_publication1_date: "2012"
};

const portfolio = {
    portfolio_work_01: "Intelligent Indoor Location System",
    portfolio_work_02: "Wireless Monitor and Security System",
    portfolio_work_03: "Android Robot Guard",
    portfolio_work_04: "Wireless Sensor Network Monitor",
    portfolio_work_05: "Disaster Monitoring and Pre-warning System",
    portfolio_work_06: "WebAccess/NMS",
    portfolio_work_07: "nCare IoT Management System",
    portfolio_work_08: "SL G-Net Management System",
    portfolio_work_09: "D-Link Edge Cloud System",
    portfolio_work_10: "Deep Learning Intelligent Traffic System",
    portfolio_work_11: "Autopilot information integration platform",
    portfolio_work_12: "AI Event Data Recorder",
    portfolio_work_13: "ZigNeural",
    portfolio_work_14: "Zigfleet"
};

const autobio = {
    autobio_title: "Autobiography",
    autobio_p1_title: "Background",
    autobio_p1_content: "I graduated and obtained my master's degree from the Department of Electronic Engineering at National Taiwan University of Science and Technology. I’d love to develop various solutions by software programming design and see the development results bring practicality and convenience to various application fields. This has inspired my career in the technology field.",
    autobio_p2_title: "The First Job Experence",
    autobio_p2_content: "After graduation, I got only two programming languages, <b>JAVA</b> and <b>SQL</b>, from school and used them in my first job immediately. This job became the first place I engaged in system platform integration and development. During this period, I learned lots of new skills, including frontend technologies such as <b>HTML</b>, <b>CSS</b>, <b>JS</b>, and <b>JSP</b>, as well as the <b>Struts 2</b> framework for JAVA backend development. I also gained experience in various communication protocols to interact with terminal devices such as <b>Restful</b>, <b>Web Socket</b>, <b>SNMP, Modbus</b>, <b>MQTT</b>, and <b>TR-069</b>. Finally, <b>Git</b> is a version control tool and one of the must-have skills I’ve learned as a standard engineer. These skills not only enrich my job and knowledge, but also let me achieve several system platform developments. And thus, I earned my supervisor’s appreciation and an outstanding talent reward in August 2016. Moreover, in 2018, I had an opportunity to further study in AI school to understand the popular technology, AI, for several months.",
    autobio_p3_title: "The Second Job Experience",
    autobio_p3_content: "Since the first job became more and more familiar, I started to seek more challenges and got the second job which is my current job. And this job indeed gives me a wealth of novel technologies. First, I develop frontend and backend by <b>ReactJS</b> and <b>NodeJS</b> which are lightweight programming languages compared to JAVA. Second, I’ve learned <b>Docker</b> for virtualize deployment and many third-party tools to build high available and reliable systems such as <b>Redis</b>, <b>RabbitMQ</b>, and <b>Keycloak</b>. Also, I’ve learned how to implement <b>CI/CD</b> to save significant development resources. In terms of self-improvement, in order to have more understand about the Agile development, which is adopted in my team, I obtained a <b>Scrum Master certification</b> in September 2021. And to further enhance my DevOps capabilities, I obtained <b>AWS SAA-C02 certification</b> In August 2022. Lastly, I had an opportunity to take on RD leader position to lead team in system development. Although it was a short-term project, it still gave me valuable experience in terms of team leadership, progress planning, task assignment, etc.",
    autobio_p4_title: "Self-Evaluation",
    autobio_p4_content: "So far, I have learned amount of technical expertise and be able to deal with cloud-based frontend and backend service development and establishment. However, there is still a long way for me to learn and improve my abilities. Especially in recent year, technology has been advancing rapidly, and I believe that the only way to overcome the future challenges is constantly learning and expanding my knowledge.",
    autobio_footer: "Considering my extensive experience in developing and my cloud-based service knowledge, I believe I’m the perfect candidate in this position at your company. If I have the chance to work in this position in future, I will fully contribute my knowledge and skills without reservation. Thank you for taking the time to read my resume."
};

export default {
    ...common,
    ...overview,
    ...resume,
    ...portfolio,
    ...autobio
};